import feRequest from "./feRequest";
const requestShort = new feRequest(process.env.VUE_APP_BASE_API, 1000 * 60);

const feRequestLong = new feRequest(
  process.env.VUE_APP_BASE_API,
  1000 * 60 * 60 * 2
);

export const axiosGet = (params) => {
  return requestShort.axiosGet(params);
};

export const axiosPost = (params) => {
  return requestShort.axiosPost(params);
};

// 导出文件
export const axiosPostDownload = (params) => {
  feRequestLong.axiosPostDownload(params);
};


/**
 * 下载 http 网址文件
 * @param {*} httpAddr
 */
export const downFilesByHttp = (httpAddr, name = null) => {
  let a = document.createElement("a");
  document.body.appendChild(a);
  a.href = httpAddr;
  a.style.display = "none";
  if (name !== null) {
    a.download = name;
  }
  a.click();
  document.body.removeChild(a);
};
